import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        {/* Logo on the left */}
        <div className="logo">
          <img src="/images/Logo.png" alt="Logo" />
        </div>
        
        {/* Navigation in the middle */}
        <nav className="nav">
          <ul>
            <li><a href="#welcome">Willkommen</a></li>
            <li><a href="#physiotherapie">Leistungen</a></li>
            <li><a href="#ueber-uns">Über uns</a></li>
            <li><a href="#kontakt">Kontakt</a></li>
          </ul>
        </nav>
        
        {/* Phone button on the right */}
        <div className="phone-button">
          <a href="tel:+495171588512">
            <span className="phone-icon">📞</span>
            <span className="phone-number">+49 5171 588512</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;